import React, { useState, useEffect, useRef } from "react";

export default function ChatbotComponent() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (isOpen && messages.length === 0) {
      setTimeout(() => {
        setMessages([
          {
            from: "bot",
            text: "¡Hola! Soy Yerika, Desarrolladora Fullstack. 💻 ¿Te gustaría conversar sobre proyectos web o contactar mis servicios?",
          },
        ]);
      }, 400);
    }
  }, [isOpen, messages]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const options = [
    { label: "Experiencia", trigger: "exp" },
    { label: "Habilidades", trigger: "skills" },
    { label: "Proyectos", trigger: "projects" },
    { label: "Escríbeme en WhatsApp", trigger: "whatsapp" },
  ];

  const handleOption = (trigger) => {
    let reply = "";
    switch (trigger) {
      case "exp":
        reply =
          "Tengo más de 2 años de experiencia desarrollando soluciones frontend con Angular, Tailwind y Material, además de backend con Python Flask y Spring Boot.";
        break;
      case "skills":
        reply =
          "Mi stack incluye Angular standalone, TypeScript, Tailwind CSS, Flask, Spring Boot, AWS Lambda, Firebase y estándares de accesibilidad WCAG 2.1 AA.";
        break;
      case "projects":
        reply =
          "He liderado proyectos como migraciones de React a Angular, chatbots con Azure AI y software especializado para empresas como ACTIVA.SA, CERTICAMARA, YEDA y Just International Logistics.";
        break;
      case "whatsapp":
        // 🚀 Redirige directamente a WhatsApp
        window.open(
          "https://wa.me/573142035583?text=Hola%20Yerika,%20interesado%20en%20tus%20servicios%20fullstack...",
          "_blank"
        );
        return; // no agrega mensajes al chat
      default:
        reply = "Lo siento, no entendí eso 😅.";
    }

    setMessages((prev) => [
      ...prev,
      { from: "user", text: options.find((o) => o.trigger === trigger)?.label },
      { from: "bot", text: reply },
    ]);
  };

  return (
    <div className="chatbot-wrapper">
      {/* Botón flotante */}
      <button
        className="chat-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir chat"
      >
        👩‍💻
      </button>

      {isOpen && (
        <div className="chat-panel">
          <div className="chat-header">
            <span>Chat con Yerika</span>
            <button
              className="close-btn"
              onClick={() => setIsOpen(false)}
              aria-label="Cerrar chat"
            >
              ✕
            </button>
          </div>

          <div className="chat-body">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`chat-bubble ${
                  msg.from === "bot" ? "bot" : "user"
                }`}
              >
                {msg.text}
              </div>
            ))}
            <div ref={bottomRef} />
          </div>

          <div className="chat-options">
            {options.map((opt) => (
              <button
                key={opt.trigger}
                onClick={() => handleOption(opt.trigger)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      )}

      <style>{`
        .chatbot-wrapper {
          position: fixed;
          bottom: 1rem;
          right: 1rem;
          z-index: 1000;
          font-family: 'Inter', sans-serif;
        }

        /* Botón flotante */
        .chat-toggle {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(145deg, #1E3A8A, #3B82F6);
          color: #fff;
          font-size: 26px;
          cursor: pointer;
          box-shadow: 0 8px 18px rgba(30, 58, 138, 0.4);
          transition: transform 0.25s ease;
        }

        .chat-toggle:hover {
          transform: scale(1.1);
        }

        /* Panel */
        .chat-panel {
          position: fixed;
          bottom: 5rem;
          right: 1rem;
          width: 340px;
          height: 520px;
          background: #f9fafb;
          border-radius: 16px;
          box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: fadeIn 0.3s ease;
        }

        .chat-header {
          background: linear-gradient(90deg, #1E3A8A, #2563EB);
          color: white;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 16px;
          letter-spacing: 0.3px;
        }

        .close-btn {
          background: transparent;
          border: none;
          color: white;
          font-size: 18px;
          cursor: pointer;
          padding: 2px 6px;
        }

        .chat-body {
          flex: 1;
          overflow-y: auto;
          padding: 14px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          scroll-behavior: smooth;
        }

        .chat-bubble {
          max-width: 85%;
          padding: 10px 14px;
          border-radius: 14px;
          line-height: 1.4;
          font-size: 14px;
          animation: fadeInUp 0.3s ease both;
          word-break: break-word;
        }

        .chat-bubble.bot {
          background: #3B82F6;
          color: white;
          align-self: flex-start;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
        }

        .chat-bubble.user {
          background: #1E3A8A;
          color: white;
          align-self: flex-end;
          box-shadow: 0 2px 8px rgba(30, 58, 138, 0.25);
        }

        .chat-options {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          padding: 10px;
          border-top: 1px solid #e5e7eb;
          background: #ffffff;
          justify-content: center;
        }

        .chat-options button {
          background: #3B82F6;
          color: white;
          border: none;
          border-radius: 10px;
          padding: 7px 12px;
          cursor: pointer;
          font-size: 13px;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .chat-options button:hover {
          background: #1E3A8A;
          transform: translateY(-1px);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* 📱 Responsive */
        @media (max-width: 640px) {
          .chat-panel {
            width: 92vw;
            height: 85vh;
            right: 50%;
            bottom: 1rem;
            transform: translateX(50%);
            border-radius: 18px;
          }

          .chat-body {
            font-size: 13.5px;
            padding: 12px;
          }

          .chat-bubble {
            max-width: 90%;
          }

          .chat-toggle {
            width: 54px;
            height: 54px;
            font-size: 24px;
          }
        }

        @media (max-width: 400px) {
          .chat-panel {
            width: 95vw;
            height: 80vh;
          }
        }
      `}</style>
    </div>
  );
}
